import { render, staticRenderFns } from "./perforDetail.vue?vue&type=template&id=2066d898&"
import script from "./perforDetail.vue?vue&type=script&lang=js&"
export * from "./perforDetail.vue?vue&type=script&lang=js&"
import style0 from "./perforDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports